const IS_DEV = process.env.NODE_ENV == 'development'
import Cookie from '@/plugins/Cookie';
import LocalStorage from '@/plugins/LocalStorage';

export default class Base {
    static IS_DEV = IS_DEV;
    static Cookie = Cookie
    static LocalStorage = LocalStorage
}
